// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { LookupTriggerWrapper } from './styles'
import lookupIcon from 'images/lookup-icon.png'

const LookupTrigger = ({ disabled, id, lookupType, toggleIsOpen }) => {
  // NOTE - LookupTriggerWrapper is a button.
  // This way user can tab to open the lookup.
  // HOWEVER, we need to preventDefault because when button[type="button"]
  // is clicked within a <form> a button[type="submit"],
  // the click event will trigger the form's onSubmit event handler.
  const handleClick = e => {
    e.preventDefault()
    toggleIsOpen()
  }

  return (
    <LookupTriggerWrapper
      className={'lookup-trigger-icon margin-left-half'}
      disabled={disabled}
      id={id}
      onClick={handleClick}
      type={'button'}>
      <img
        alt={`${lookupType || ''} lookup icon`}
        src={lookupIcon} />
    </LookupTriggerWrapper>
  )
}

LookupTrigger.propTypes = {
  disabled: bool,
  id: string.isRequired,
  lookupType: string,
  toggleIsOpen: func.isRequired,
}

export default LookupTrigger
